import React from 'react';
import { Box, Typography, Grid, Container } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import VerifiedIcon from '@mui/icons-material/Verified';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

const items = [
  { icon: <SchoolIcon sx={{ fontSize:28, color:'#684df4' }} />, label:'500+ Institutions Trust Us' },
  { icon: <PeopleAltIcon sx={{ fontSize:28, color:'#684df4' }} />, label:'50,000+ Students Enrolled' },
  { icon: <VerifiedIcon sx={{ fontSize:28, color:'#684df4' }} />, label:'ISO Certified Platform' },
  { icon: <SupportAgentIcon sx={{ fontSize:28, color:'#684df4' }} />, label:'24/7 Priority Support' },
];

const TrustBar = () => (
  <Box sx={{ bgcolor:'#fff', borderBottom:'1px solid #ede9fe', py:3, boxShadow:'0 4px 24px rgba(104,77,244,0.06)' }}>
    <Container maxWidth="lg">
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        {items.map((it, i) => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <Box sx={{ display:'flex', alignItems:'center', gap:1.5, justifyContent:{ xs:'center', md:'flex-start' } }}>
              <Box sx={{ width:48, height:48, borderRadius:'12px', bgcolor:'rgba(104,77,244,0.08)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                {it.icon}
              </Box>
              <Typography sx={{ fontWeight:600, fontSize:14, color:'#141d38', fontFamily:"'Montserrat', sans-serif" }}>{it.label}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);

export default TrustBar;
